import { Element } from "../Element.mjs";
import { isEnum, isObject, isUuid } from "../validation/index.mjs";
export var StoryEmbedNode;

(function (StoryEmbedNode) {
  StoryEmbedNode.TYPE = 'story-embed';
  var Appearance;

  (function (Appearance) {
    Appearance["INTRO"] = "intro";
    Appearance["FULL"] = "full";
  })(Appearance = StoryEmbedNode.Appearance || (StoryEmbedNode.Appearance = {}));

  var Position;

  (function (Position) {
    Position["CENTER"] = "center";
    Position["LEFT"] = "left";
    Position["RIGHT"] = "right";
  })(Position = StoryEmbedNode.Position || (StoryEmbedNode.Position = {}));

  function isStoryEmbedNode(value) {
    return Element.isElement(value, StoryEmbedNode.TYPE);
  }

  StoryEmbedNode.isStoryEmbedNode = isStoryEmbedNode;

  function validateStoryEmbedNode(node) {
    var isValid = isStoryEmbedNode(node) && isObject(node.story) && isUuid(node.story.uuid) && isEnum(node.appearance, Appearance) && isEnum(node.position, Position);
    return isValid ? node : null;
  }

  StoryEmbedNode.validateStoryEmbedNode = validateStoryEmbedNode;
})(StoryEmbedNode || (StoryEmbedNode = {}));